export default __webpack_public_path__ + "_/shared_modules/base-layout/img/logo_equal_housing_lender_white-d7e42f793b9d1cc782d2dbc46e1a5597.svg";